import type { ReceiptListRow } from "../hooks/useReceiptsList";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

// Narrow shape so the helper can be tested against a stub without dragging
// the full ReactLocalization type into unit tests. Variables match
// @fluent/react's FluentVariable union (numbers and strings cover the
// placeables this helper uses).
export type ReasonCopyVariable = string | number;
export interface ReasonCopyL10n {
  getString: (
    id: string,
    vars?: Record<string, ReasonCopyVariable> | null
  ) => string;
}

export const getReasonCopy = (
  row: ReceiptListRow,
  now: Date,
  l10n: ReasonCopyL10n
): string => {
  switch (row.status) {
    case "no_match": {
      if (row.no_match_reason === "user_unlinked") {
        return l10n.getString("receipts-reason-unlinked");
      }
      if (
        row.no_match_reason === "matcher_found_none" &&
        row.retry_expires_at
      ) {
        const expiresAt = new Date(row.retry_expires_at);
        // Ceil + positive gate mirrors UnmatchedEmptyCard so retry copy
        // never shows "0 days remaining" while the window is still open
        // (a < 24h remainder would floor to 0 with differenceInDays).
        const days = Math.ceil(
          (expiresAt.getTime() - now.getTime()) / MS_PER_DAY
        );
        if (days > 0) {
          return l10n.getString("receipts-reason-no-match-retrying", { days });
        }
      }
      return l10n.getString("receipts-reason-no-match");
    }
    case "rejected":
      return l10n.getString("receipts-reason-match-rejected");
    case "orphaned":
      return l10n.getString("receipts-reason-orphaned");
    case "extraction_failed":
      return l10n.getString("receipts-reason-extraction-failed");
    default:
      return "";
  }
};
